import { ChallengeNameType } from '@aws-sdk/client-cognito-identity-provider';
import { FC } from 'react';
import { match } from 'ts-pattern';

import { PasswordPolicyType } from '@/types/ui-auth-rust-types';

// import MFAForm from './mfa';
import SetPasswordForm, { FormValues as SetPasswordFormValues } from './set-password';

export type FormValues = SetPasswordFormValues;

export const Challenge = {
  ...ChallengeNameType,
  RESET_PASSWORD: 'RESET_PASSWORD',
} as const;

export type Challenge = (typeof Challenge)[keyof typeof Challenge];

export interface ChallengeDetails {
  challengeName: Challenge;
  passwordPolicy?: PasswordPolicyType;
  session: string | null;
}

interface Properties {
  email: string;
  password?: string;
  challengeCode?: string;
  onSubmit: (form: Omit<FormValues, 'confirmPassword'>) => void;
  onCancel: () => void;
  challenge: ChallengeDetails;
}

const ChallengeForm: FC<Properties> = ({ email, password, challengeCode, onSubmit, onCancel, challenge }) => {
  return match(challenge.challengeName)
    .with(Challenge.RESET_PASSWORD, Challenge.NEW_PASSWORD_REQUIRED, (challengeName) => {
      if (!challenge.passwordPolicy) {
        return null;
      }

      return (
        <SetPasswordForm
          onSubmit={onSubmit}
          passwordPolicy={challenge.passwordPolicy}
          defaultValues={{ email, password, challengeName, challengeCode, session: challenge.session }}
          onCancel={onCancel}
        />
      );
    })
    .with(
      Challenge.SELECT_MFA_TYPE,
      Challenge.SMS_MFA,
      Challenge.SOFTWARE_TOKEN_MFA,
      Challenge.ADMIN_NO_SRP_AUTH,
      Challenge.CUSTOM_CHALLENGE,
      Challenge.DEVICE_PASSWORD_VERIFIER,
      Challenge.DEVICE_SRP_AUTH,
      Challenge.MFA_SETUP,
      Challenge.PASSWORD_VERIFIER,
      () => null,
    )
    .exhaustive();
};

export default ChallengeForm;
